/*
* @Author: 曹俊杰
* @Date: 2022-05-10 17:52:49
* @Module: 广场信息
*/
<template>
  <div class="Information">
      <div class="left">
          <listMenu v-for="item in menuList" :itemData="item" :key="item.name" pathPrefix="Information"/>
      </div>
      <div class="right">
          <keep-alive>
              <router-view />
          </keep-alive>
      </div>
  </div>
</template>
<script>
import listMenu from '@/components/listMenu/listMenu.vue';
export default {
  components: {
      listMenu
  },
  data() {
    return {
      menuList: [
        {
          title: '广场信息',
          name: 'InformationList',
          icon: 'el-icon-ali-hetongmoban'
        },
        {
          title: '我的发布',
          name: 'InformationMy',
          icon: 'el-icon-ali-wodegoumai',
          authority: []
        }
      ]
    };
  },
}
</script>
<style lang='scss' scoped>
.Information {
  @include contentStyle2;
}
</style>